export const FINANCE_API = {
  ACCOUNT_TYPE: {
    CASH_JOURNAL: 'cashJournal',
    CASH_JOURNAL_POS: 'cashJournalPos',
    CLEARING_ACCOUNT: 'clearingAccount',
    CLEARING_ACCOUNT_POS: 'clearingAccountPos',
    CLEARING_ACCOUNT_PAYPAL: 'transferPaypal',
    GIRO: 'giro',
    CREDIT: 'credit',
    CREDIT_CARD: 'creditCard',
    DEPOT: 'depot',
    PAYPAL: 'payPal',
    OFFLINE_ACCOUNT: 'offlineBankAccount',
    SHOPIFY_POS: 'shopifyPos',
    SHOPIFY_PAYMENTS: 'shopifyPayments',
    BANKBOOK: 'bankBook',
  },
  CONTACT_TYPE: {
    OFFLINE: 'offline',
    INTERNAL: 'internal',
    BANK: 'bank',
    SHOPIFY_PAYMENTS: 'shopifyPayments',
    KLARNA: 'klarna',
    STRIPE: 'stripe',
  },
  ASSIGNMENT_STATE: {
    NOT_ASSIGNED: 'notAssigned',
    FULLY_ASSIGNED: 'fullyAssigned',
    PARTIALLY_ASSIGNED: 'partiallyAssigned',
  },
  TRANSACTION_STATE: {
    RUNNING: 'running',
    QUEUED: 'queued',
    FAILED: 'failed',
    CANCELED: 'canceled',
    SUCCEEDED: 'succeeded',
    CANCELLATION_REQUESTED: 'cancellationRequested',
    WAITING_FOR_PIN_CALLBACK: 'waitingForPinCallback',
    WAITING_FOR_TAN_CALLBACK: 'waitingForTanCallback',
    WAITING_FOR_UNIVERSAL_CALLBACK: 'waitingForUniversalCallback',
    WAITING_FOR_REDIRECT_CALLBACK: 'waitingForRedirectCallback',
    WAITING_FOR_VALIDATION_CALLBACK: 'waitingForValidationCallback',
    WAITING_FOR_CONTACT_CHANGE_CALLBACK: 'waitingForContactChangeCallback',
  },
  CONTACT_SETUP_REQUIRED_STATE: {
    NO_ACTION_NECESSARY: 0,
    CONTACT_SETUP_POSSIBLE: 1,
    CONTACT_SETUP_MANDATORY: 2,
  },
  CASH_BOOKING_TYPES: {
    DEPOSIT: 'deposit',
    WITHDRAWAL: 'withdrawal',
  },
  TAN_CALLBACK_TYPES: {
    INPUT: 'input',
    DECOUPLED_AUTOMATIC: 'decoupledAutomatic',
    DECOUPLED_MANUAL: 'decoupledManual',
  },
  REVENUE_ACCOUNT_VATTYPE_OPTIONS: {
    ADD_CURRENT_TENANT_VATTYPE: 1,
    REMOVE_CURRENT_TENANT_VATTYPE: 2,
  },
}

export const ALLOWED_ACCOUNT_TYPES = {
  CLEAR_ASSIGNMENT: [
    FINANCE_API.ACCOUNT_TYPE.CASH_JOURNAL,
    FINANCE_API.ACCOUNT_TYPE.CASH_JOURNAL_POS,
    FINANCE_API.ACCOUNT_TYPE.GIRO,
    FINANCE_API.ACCOUNT_TYPE.CREDIT_CARD,
    FINANCE_API.ACCOUNT_TYPE.CREDIT,
    FINANCE_API.ACCOUNT_TYPE.DEPOT,
    FINANCE_API.ACCOUNT_TYPE.PAYPAL,
    FINANCE_API.ACCOUNT_TYPE.CLEARING_ACCOUNT,
    FINANCE_API.ACCOUNT_TYPE.CLEARING_ACCOUNT_POS,
    FINANCE_API.ACCOUNT_TYPE.OFFLINE_ACCOUNT,
  ],
  PRIVATE_ASSIGNMENT: [
    FINANCE_API.ACCOUNT_TYPE.CASH_JOURNAL_POS,
  ],
  CREATE_EXPENSE_OR_REVENUE: [
    FINANCE_API.ACCOUNT_TYPE.CASH_JOURNAL,
    FINANCE_API.ACCOUNT_TYPE.GIRO,
    FINANCE_API.ACCOUNT_TYPE.CREDIT_CARD,
    FINANCE_API.ACCOUNT_TYPE.CREDIT,
    FINANCE_API.ACCOUNT_TYPE.DEPOT,
    FINANCE_API.ACCOUNT_TYPE.PAYPAL,
    FINANCE_API.ACCOUNT_TYPE.CLEARING_ACCOUNT,
    FINANCE_API.ACCOUNT_TYPE.OFFLINE_ACCOUNT,
    FINANCE_API.ACCOUNT_TYPE.BANKBOOK,
  ],
  CREATE_INTERNAL_TRANSFER: [
    FINANCE_API.ACCOUNT_TYPE.GIRO,
    FINANCE_API.ACCOUNT_TYPE.CREDIT_CARD,
    FINANCE_API.ACCOUNT_TYPE.CREDIT,
    FINANCE_API.ACCOUNT_TYPE.DEPOT,
  ],
  ASSIGN_INTERNAL_TRANSFER: [
    FINANCE_API.ACCOUNT_TYPE.GIRO,
    FINANCE_API.ACCOUNT_TYPE.PAY_PAL,
    FINANCE_API.ACCOUNT_TYPE.CREDIT_CARD,
    FINANCE_API.ACCOUNT_TYPE.CREDIT,
    FINANCE_API.ACCOUNT_TYPE.DEPOT,
    FINANCE_API.ACCOUNT_TYPE.CASH_JOURNAL,
  ],
}

export const BOOKING_ASSISTANT = {
  UPDATE_TYPES: {
    ASSIGNMENT_CREATED: 'assignmentCreated',
    ASSIGNMENT_REMOVED: 'assignmentRemoved',
  },
  CONTENT_TYPES: {
    ASSIGNMENT_DETAILS: 'assignmentDetails',
    CREATE_EXPENSE: 'createExpense',
    CREATE_REVENUE: 'createRevenue',
    CREATE_INTERNAL_TRANSFER: 'internalTransferCreate',
    ASSIGN_INTERNAL_TRANSFER: 'internalTransferAssign',
    ASSIGN_DOCUMENT: 'joinDocument',
  },
}
